import { del, get, post, postMulti, put } from "./api_helper";
import * as url from "./url_helper_api";

const postLogin = data => post(url.POST_LOGIN, data);
const postLogout = data => post(url.POST_LOGIN, data);

// profile
const onProfileView = (url_) => get(`${url.VIEW_PROFILE}${url_}`);
const onDashboardAnalytic = (url_) => get(`${url.DASHBOARD_ANALYTIC}${url_}`);
const onProfileUpdate = (data, url_) => put(`${url.EDIT_PROFILE}/${url_}`, data);
const onPasswordChange = (data, url_) => put(`${url.PASSWORD_CHANGE}/${url_}`, data);

// aspirations question
const onAddAspirationsQuestion = data => post(url.ASPIRATION_QUESTION_CREATE, data);
const onEditAspirationsQuestion = (data, id) => put(`${url.ASPIRATION_QUESTION_UPDATE}/${id}`, data);
const onListAspirationsQuestion = data => post(url.ASPIRATION_QUESTION_LIST, data);
const onViewAspirationsQuestion = data => get(`${url.ASPIRATION_QUESTION_VIEW}/${data}`);
const onSortAspirationsQuestion = (data, id) => post(`${url.ASPIRATION_QUESTION_SORT}/${id}`, data);
const onDeleteAspirationsQuestion = data => del(`${url.ASPIRATION_QUESTION_DELETE}`, data);

// aspirations text
const onAddAspirationsText = (data, id) => post(`${url.ASPIRATION_TEXT_CREATE}`, data);
const onEditAspirationsText = (data, id) => put(`${url.ASPIRATION_TEXT_UPDATE}/${id}`, data);
const onListAspirationsText = (data, id) => post(`${url.ASPIRATION_TEXT_LIST}/${id}/text/list`, data);
const onViewAspirationsText = (id) => get(`${url.ASPIRATION_TEXT_VIEW}/${id}`);
const onDeleteAspirationsText = data => del(`${url.ASPIRATION_TEXT_DELETE}`, data);


// schor horizontal
const onAddSchorHorizontal = data => post(url.SCHOR_HORIZONTAL_CREATE, data);
const onEditSchorHorizontal = (data, id) => put(`${url.SCHOR_HORIZONTAL_UPDATE}/${id}`, data);
const onListSchorHorizontal = data => post(url.SCHOR_HORIZONTAL_LIST, data);
const onViewSchorHorizontal = data => get(`${url.SCHOR_HORIZONTAL_VIEW}/${data}`);
const onSortSchorHorizontal = (data, id) => post(`${url.SCHOR_HORIZONTAL_SORT}/${id}`, data);
const onDeleteSchorHorizontal = data => del(`${url.SCHOR_HORIZONTAL_DELETE}`, data);

// schor horizontal text
const onAddSchorHorizontalText = (data, id) => post(`${url.SCHOR_HORIZONTAL_TEXT_CREATE}`, data);
const onEditSchorHorizontalText = (data, id) => put(`${url.SCHOR_HORIZONTAL_TEXT_UPDATE}/${id}`, data);
const onListSchorHorizontalText = (data, id) => post(`${url.SCHOR_HORIZONTAL_TEXT_LIST}/${id}/text/list`, data);
const onViewSchorHorizontalText = (id) => get(`${url.SCHOR_HORIZONTAL_TEXT_VIEW}/${id}`);
const onDeleteSchorHorizontalText = data => del(`${url.SCHOR_HORIZONTAL_TEXT_DELETE}`, data);

// schor vertical
const onAddSchorVertical = data => post(url.SCHOR_VERTICAL_CREATE, data);
const onEditSchorVertical = (data, id) => put(`${url.SCHOR_VERTICAL_UPDATE}/${id}`, data);
const onListSchorVertical = data => post(url.SCHOR_VERTICAL_LIST, data);
const onViewSchorVertical = data => get(`${url.SCHOR_VERTICAL_VIEW}/${data}`);
const onSortSchorVertical = (data, id) => post(`${url.SCHOR_VERTICAL_SORT}/${id}`, data);
const onDeleteSchorVertical = data => del(`${url.SCHOR_VERTICAL_DELETE}`, data);

// schor vertical text
const onAddSchorVerticalText = (data, id) => post(`${url.SCHOR_VERTICAL_TEXT_CREATE}`, data);
const onEditSchorVerticalText = (data, id) => put(`${url.SCHOR_VERTICAL_TEXT_UPDATE}/${id}`, data);
const onListSchorVerticalText = (data, id) => post(`${url.SCHOR_VERTICAL_TEXT_LIST}/${id}/text/list`, data);
const onViewSchorVerticalText = (id) => get(`${url.SCHOR_VERTICAL_TEXT_VIEW}/${id}`);
const onDeleteSchorVerticalText = data => del(`${url.SCHOR_VERTICAL_TEXT_DELETE}`, data);


// questionnaire
const onAddQuestionnaire = data => post(url.QUESTIONNAIRE_CREATE, data);
const onEditQuestionnaire = (data, id) => put(`${url.QUESTIONNAIRE_UPDATE}/${id}`, data);
const onListQuestionnaire = data => post(url.QUESTIONNAIRE_LIST, data);
const onViewQuestionnaire = data => get(`${url.QUESTIONNAIRE_VIEW}/${data}`);
const onSortQuestionnaire = (data, id) => post(`${url.QUESTIONNAIRE_SORT}/${id}`, data);
const onDeleteQuestionnaire = data => del(`${url.QUESTIONNAIRE_DELETE}`, data);

// questionnaire text
const onAddQuestionnaireText = (data, id) => post(`${url.QUESTIONNAIRE_TEXT_CREATE}`, data);
const onEditQuestionnaireText = (data, id) => put(`${url.QUESTIONNAIRE_TEXT_UPDATE}/${id}`, data);
const onListQuestionnaireText = (data, id) => post(`${url.QUESTIONNAIRE_TEXT_LIST}/${id}/question/list`, data);
const onViewQuestionnaireText = (id) => get(`${url.QUESTIONNAIRE_TEXT_VIEW}/${id}`);
const onDeleteQuestionnaireText = data => del(`${url.QUESTIONNAIRE_TEXT_DELETE}`, data);
const onSortQuestionnaireQuestion = (data, id, mainId) => post(`${url.QUESTIONNAIRE_QUESTIONS_SORT}/${mainId}/question/sort/${id}`, data);


// Email
const onSendBatchEmail = (id, type) => get(`${url.SEND_BATCH_MAIL}/${id}/${type}`);
const onListBatchMail = data => post(`${url.BATCH_MAIL_LIST}`, data);

// Norms 
const onGenerateGlobalNorms = (id) => put(`${url.GENERATE_GLOBAL_NORMS}`);
const onGetGlobalNormsList = data => get(`${url.GLOBAL_NORMS_LIST}`, data);
const onCreateGroupNorms = data => post(`${url.GROUP_NORMS_CREATE}`, data);
const onGetGroupNormsList = data => get(`${url.GROUP_NORMS_LIST}/${data}`);
const onGetGroupNormsDetailList = data => get(`${url.GROUP_NORMS_LIST_DETAILS}`, data);

// Invitation
//Participants Invites
const onAddParticipantsInvites = data => post(url.PARTICIPANTS_INVITES_CREATE, data);
const onEditParticipantsInvites = (data, id) => put(`${url.PARTICIPANTS_INVITES_UPDATE}/${id}`, data);
const onListParticipantsInvites = data => post(url.PARTICIPANTS_INVITES_LIST, data);
const onViewParticipantsInvites = data => get(`${url.PARTICIPANTS_INVITES_VIEW}/${data}`);
const onSortParticipantsInvites = (data, id) => post(`${url.PARTICIPANTS_INVITES_SORT}/${id}`, data);
const onDeleteParticipantsInvites = data => del(`${url.PARTICIPANTS_INVITES_DELETE}`, data);

//Participants Invites text
const onAddParticipantsInvitesText = (data, id) => post(`${url.PARTICIPANTS_INVITES_TEXT_CREATE}`, data);
const onEditParticipantsInvitesText = (data, id) => put(`${url.PARTICIPANTS_INVITES_TEXT_UPDATE}/${id}`, data);
const onListParticipantsInvitesText = (data, id) => post(`${url.PARTICIPANTS_INVITES_TEXT_LIST}/${id}/text/list`, data);
const onViewParticipantsInvitesText = (id) => get(`${url.PARTICIPANTS_INVITES_TEXT_VIEW}/${id}`);
const onDeleteParticipantsInvitesText = data => del(`${url.PARTICIPANTS_INVITES_TEXT_DELETE}`, data);


//Raters Invites
const onAddRatersInvites = data => post(url.RATERS_INVITES_CREATE, data);
const onEditRatersInvites = (data, id) => put(`${url.RATERS_INVITES_UPDATE}/${id}`, data);
const onListRatersInvites = data => post(url.RATERS_INVITES_LIST, data);
const onViewRatersInvites = data => get(`${url.RATERS_INVITES_VIEW}/${data}`);
const onSortRatersInvites = (data, id) => post(`${url.RATERS_INVITES_SORT}/${id}`, data);
const onDeleteRatersInvites = data => del(`${url.RATERS_INVITES_DELETE}`, data);

//Raters Invites text
const onAddRatersInvitesText = (data, id) => post(`${url.RATERS_INVITES_TEXT_CREATE}`, data);
const onEditRatersInvitesText = (data, id) => put(`${url.RATERS_INVITES_TEXT_UPDATE}/${id}`, data);
const onListRatersInvitesText = (data, id) => post(`${url.RATERS_INVITES_TEXT_LIST}/${id}/text/list`, data);
const onViewRatersInvitesText = (id) => get(`${url.RATERS_INVITES_TEXT_VIEW}/${id}`);
const onDeleteRatersInvitesText = data => del(`${url.RATERS_INVITES_TEXT_DELETE}`, data);

// Reminders
//Participants Reminders
const onAddParticipantsReminders = data => post(url.PARTICIPANTS_REMINDERS_CREATE, data);
const onEditParticipantsReminders = (data, id) => put(`${url.PARTICIPANTS_REMINDERS_UPDATE}/${id}`, data);
const onListParticipantsReminders = data => post(url.PARTICIPANTS_REMINDERS_LIST, data);
const onViewParticipantsReminders = data => get(`${url.PARTICIPANTS_REMINDERS_VIEW}/${data}`);
const onSortParticipantsReminders = (data, id) => post(`${url.PARTICIPANTS_REMINDERS_SORT}/${id}`, data);
const onDeleteParticipantsReminders = data => del(`${url.PARTICIPANTS_REMINDERS_DELETE}`, data);

//Participants Reminders text
const onAddParticipantsRemindersText = (data, id) => post(`${url.PARTICIPANTS_REMINDERS_TEXT_CREATE}`, data);
const onEditParticipantsRemindersText = (data, id) => put(`${url.PARTICIPANTS_REMINDERS_TEXT_UPDATE}/${id}`, data);
const onListParticipantsRemindersText = (data, id) => post(`${url.PARTICIPANTS_REMINDERS_TEXT_LIST}/${id}/text/list`, data);
const onViewParticipantsRemindersText = (id) => get(`${url.PARTICIPANTS_REMINDERS_TEXT_VIEW}/${id}`);
const onDeleteParticipantsRemindersText = data => del(`${url.PARTICIPANTS_REMINDERS_TEXT_DELETE}`, data);

// batches
const onAddBatch = data => post(url.BATCH_CREATE, data);
const onEditBatch = (data, id) => put(`${url.BATCH_UPDATE}/${id}`, data);
const onListBatch = data => post(url.BATCH_LIST, data);
const onListBatchTrack = id => get(`${url.BATCH_TRACK_LIST}/${id}`);
const onViewBatch = data => get(`${url.BATCH_VIEW}/${data}`);
const onSortBatch = (data, id) => post(`${url.BATCH_SORT}/${id}`, data);
const onDeleteBatch = data => del(`${url.BATCH_DELETE}`, data);

const onBatchGroupReport = (id, langId) => get(`${url.BATCH_GROUP_REPORT}/${id}/${langId}`);
const onScoreBatch = (id, langId) => get(`${url.SCORE_BATCH}/${id}/${langId}`);
const onParticipantScorePDF = data => get(`${url.PARTICIPANT_SCORE_PDF}/${data}`);

// participants
const onAddParticipants = (data, id) => post(`${url.PARTICIPANTS_CREATE}/${id}/participant/create`, data);
const onEditParticipants = (data, id) => put(`${url.PARTICIPANTS_UPDATE}/participant/update/${id}`, data);
const onListParticipants = (data, id) => post(`${url.PARTICIPANTS_LIST}/${id}/participant/list`, data);
const onListTrackParticipants = (participantId, trackId) => get(`${url.PARTICIPANTS_TRACK_LIST}/participant/track/${participantId}/${trackId}`);
const onViewParticipants = (id) => get(`${url.PARTICIPANTS_VIEW}/${id}`);
const onDeleteParticipants = data => del(`${url.PARTICIPANTS_DELETE}/participant/delete`, data);
const onSendInvitationMail = (id) => get(`${url.SEND_INVITATION_MAIL}/${id}`);
const onUploadCSVFile = (id, data) => postMulti(`${url.UPLOAD_CSV_PARTICIPANT}/${id}/participant/import`, data);
const onPeersMerge = (id) => get(`${url.PEERS_MERGE}/${id}`);


//Configurations
//Language
const onAddLanguage = data => post(url.LANGUAGE_CREATE, data);
const onEditLanguage = (data, id) => put(`${url.LANGUAGE_UPDATE}/${id}`, data);
const onListLanguage = data => post(url.LANGUAGE_LIST, data);
const onViewLanguage = data => get(`${url.LANGUAGE_VIEW}/${data}`);
const onSortLanguage = (data, id) => post(`${url.LANGUAGE_SORT}/${id}`, data);
const onDeleteLanguage = data => del(`${url.LANGUAGE_DELETE}`, data);

//ChartColor
const onEditChartColor = (data, id) => put(`${url.CHARTCOLOR_UPDATE}/${id}`, data);
const onListChartColor = data => get(url.CHARTCOLOR_LIST, data);

//Survey Welcome
const onAddSurveyWelcome = data => post(url.SURVEY_WELCOME_CREATE, data);
const onEditSurveyWelcome = (data, id) => put(`${url.SURVEY_WELCOME_UPDATE}/${id}`, data);
const onListSurveyWelcome = data => post(url.SURVEY_WELCOME_LIST, data);
const onViewSurveyWelcome = data => get(`${url.SURVEY_WELCOME_VIEW}/${data}`);
const onSortSurveyWelcome = (data, id) => post(`${url.SURVEY_WELCOME_SORT}/${id}`, data);
const onDeleteSurveyWelcome = data => del(`${url.SURVEY_WELCOME_DELETE}`, data);


//Survey Middle
const onAddSurveyMiddle = data => post(url.SURVEY_MIDDLE_CREATE, data);
const onEditSurveyMiddle = (data, id) => put(`${url.SURVEY_MIDDLE_UPDATE}/${id}`, data);
const onListSurveyMiddle = data => post(url.SURVEY_MIDDLE_LIST, data);
const onViewSurveyMiddle = data => get(`${url.SURVEY_MIDDLE_VIEW}/${data}`);
const onSortSurveyMiddle = (data, id) => post(`${url.SURVEY_MIDDLE_SORT}/${id}`, data);
const onDeleteSurveyMiddle = data => del(`${url.SURVEY_MIDDLE_DELETE}`, data);

//Survey thank you
const onAddThankYou = data => post(url.THANK_YOU_CREATE, data);
const onEditThankYou = (data, id) => put(`${url.THANK_YOU_UPDATE}/${id}`, data);
const onListThankYou = data => post(url.THANK_YOU_LIST, data);
const onViewThankYou = data => get(`${url.THANK_YOU_VIEW}/${data}`);
const onSortThankYou = (data, id) => post(`${url.THANK_YOU_SORT}/${id}`, data);
const onDeleteThankYou = data => del(`${url.THANK_YOU_DELETE}`, data);

//Raters Type
const onAddRatersType = data => post(url.RATERS_TYPE_CREATE, data);
const onEditRatersType = (data, id) => put(`${url.RATERS_TYPE_UPDATE}/${id}`, data);
const onListRatersType = data => post(url.RATERS_TYPE_LIST, data);
const onViewRatersType = data => get(`${url.RATERS_TYPE_VIEW}/${data}`);
const onSortRatersType = (data, id) => post(`${url.RATERS_TYPE_SORT}/${id}`, data);
const onDeleteRatersType = data => del(`${url.RATERS_TYPE_DELETE}`, data);

// Raters Type text
const onAddRatersTypeText = (data, id) => post(`${url.RATERS_TYPE_TEXT_CREATE}`, data);
const onEditRatersTypeText = (data, id) => put(`${url.RATERS_TYPE_TEXT_UPDATE}/${id}`, data);
const onListRatersTypeText = (data, id) => post(`${url.RATERS_TYPE_TEXT_LIST}/${id}/text/list`, data);
const onViewRatersTypeText = (id) => get(`${url.RATERS_TYPE_TEXT_VIEW}/${id}`);
const onDeleteRatersTypeText = data => del(`${url.RATERS_TYPE_TEXT_DELETE}`, data);

// utility
// lanaguage
const fetchLanguageList = data => get(url.LANGUAGE);
const fetchQuestionList = data => get(url.QUESTION, data);
const fetchQuestionnaireList = data => get(url.QUESTIONNAIRE, data);
const fetchQuestionnaireBatchList = data => get(`${url.QUESTIONNAIRE_BATCH}/${data}`);
const ratersInvitationsList = data => get(url.RATERS_INVITATIONS, data);
const participantsInvitaionsList = data => get(url.PARTICIPANTS_INVITATIONS, data);
const ratersRemindersList = data => get(url.RATERS_REMINDERS, data);
const participantsRemindersList = data => get(url.PARTICIPANTS_REMINDERS, data);


// ******************************** => Participant // Rater Panel <= **************************************
const postParticipantLogin = (data, type) => post(`${url.POST_PARTICIPANT_LOGIN}/${type}/auth/login`, data);
const postParticipantLogout = (data, type) => post(`${url.POST_PARTICIPANT_LOGOUT}/${type}/auth/logout`, data);

// profile
const onParticipantProfileView = data => get(`${url.VIEW_PARTICIPANT_PROFILE}/${type}/auth/me`, data);
const onParticipantProfileUpdate = data => put(`${url.EDIT_PARTICIPANT_PROFILE}/${type}`, data);
const onParticipantPasswordChange = data => put(`${url.PASSWORD_PARTICIPANT_CHANGE}/${type}`, data);

//Raters invite
const onSendMail = (data, id) => put(`${url.SEND_MAIL}/${id}`, data);
const onRatersInviteList = data => get(url.RATERS_INVITE_LIST, data);
const getTemplate = data => post(url.GET_TEMPLATE, data);

// Survey
const surveyList = (type) => get(`${url.SURVEY_LIST}/${type}`);
const surveyEdit = (data, type) => put(`${url.SURVEY_EDIT}/${type}`, data);
const getQuestionById = (id, type) => get(`${url.GET_QUESTION}/${type}/answer/${id}`);
const mailInvite = (data, type) => post(`${url.MAIL_INVITE}`, data);
const onSaveQuestionAnswer = (data, type) => post(`${url.SAVE_QUESTION_ANSWER}/${type}`, data);
const onSaveFinalsubmissionQuestionAnswer = (data, type) => post(`${url.SAVE_QUESTION_ANSWER}/${type}/submit`, data);

// utility
const getHorizontalList = data => get(url.HORIZONTAL_LIST, data);
const getVerticalList = data => get(url.VERTICAL_LIST, data);


export {
    postLogin,
    onDashboardAnalytic,
    // aspiration quesion
    onAddAspirationsQuestion,
    onEditAspirationsQuestion,
    onListAspirationsQuestion,
    onViewAspirationsQuestion,
    onDeleteAspirationsQuestion,
    onSortAspirationsQuestion,
    //aspiration quesion text
    onAddAspirationsText,
    onEditAspirationsText,
    onListAspirationsText,
    onViewAspirationsText,
    onDeleteAspirationsText,

    // schor horizontal
    onAddSchorHorizontal,
    onEditSchorHorizontal,
    onListSchorHorizontal,
    onViewSchorHorizontal,
    onDeleteSchorHorizontal,
    onSortSchorHorizontal,
    // schor horizontal text
    onAddSchorHorizontalText,
    onEditSchorHorizontalText,
    onListSchorHorizontalText,
    onViewSchorHorizontalText,
    onDeleteSchorHorizontalText,

    // schor vertical
    onAddSchorVertical,
    onEditSchorVertical,
    onListSchorVertical,
    onViewSchorVertical,
    onDeleteSchorVertical,
    onSortSchorVertical,

    // schor vertical text
    onAddSchorVerticalText,
    onEditSchorVerticalText,
    onListSchorVerticalText,
    onViewSchorVerticalText,
    onDeleteSchorVerticalText,

    // quesionnaire
    onAddQuestionnaire,
    onEditQuestionnaire,
    onListQuestionnaire,
    onViewQuestionnaire,
    onDeleteQuestionnaire,
    onSortQuestionnaire,
    //quesionnaire text
    onAddQuestionnaireText,
    onEditQuestionnaireText,
    onListQuestionnaireText,
    onViewQuestionnaireText,
    onDeleteQuestionnaireText,
    onSortQuestionnaireQuestion,

    // participants invites
    onAddParticipantsInvites,
    onEditParticipantsInvites,
    onListParticipantsInvites,
    onViewParticipantsInvites,
    onDeleteParticipantsInvites,
    onSortParticipantsInvites,
    //participants invites text
    onAddParticipantsInvitesText,
    onEditParticipantsInvitesText,
    onListParticipantsInvitesText,
    onViewParticipantsInvitesText,
    onDeleteParticipantsInvitesText,

    // raters invites
    onAddRatersInvites,
    onEditRatersInvites,
    onListRatersInvites,
    onViewRatersInvites,
    onDeleteRatersInvites,
    onSortRatersInvites,
    //Raters invites text
    onAddRatersInvitesText,
    onEditRatersInvitesText,
    onListRatersInvitesText,
    onViewRatersInvitesText,
    onDeleteRatersInvitesText,

    // participants Reminders
    onAddParticipantsReminders,
    onEditParticipantsReminders,
    onListParticipantsReminders,
    onViewParticipantsReminders,
    onDeleteParticipantsReminders,
    onSortParticipantsReminders,
    //participants Reminders text
    onAddParticipantsRemindersText,
    onEditParticipantsRemindersText,
    onListParticipantsRemindersText,
    onViewParticipantsRemindersText,
    onDeleteParticipantsRemindersText,

    // batches
    onAddBatch,
    onEditBatch,
    onListBatch,
    onListBatchTrack,
    onViewBatch,
    onDeleteBatch,
    onSortBatch,
    onBatchGroupReport, 
    onScoreBatch, 
    onParticipantScorePDF,

    //participants
    onAddParticipants,
    onEditParticipants,
    onListParticipants,
    onListTrackParticipants,
    onViewParticipants,
    onDeleteParticipants,
    onSendInvitationMail,
    onUploadCSVFile,
    onPeersMerge,

    // Email
    onSendBatchEmail,
    onListBatchMail,

    onGenerateGlobalNorms, 
    onGetGlobalNormsList, 
    onCreateGroupNorms, 
    onGetGroupNormsList, 
    onGetGroupNormsDetailList,

    //Configuration Language
    onAddLanguage,
    onEditLanguage,
    onListLanguage,
    onViewLanguage,
    onSortLanguage,
    onDeleteLanguage,

    //Configuration ChartColor
    onEditChartColor,
    onListChartColor,

    //Survey Welcome
    onAddSurveyWelcome,
    onEditSurveyWelcome,
    onListSurveyWelcome,
    onViewSurveyWelcome,
    onSortSurveyWelcome,
    onDeleteSurveyWelcome,

    //Survey middle
    onAddSurveyMiddle,
    onEditSurveyMiddle,
    onListSurveyMiddle,
    onViewSurveyMiddle,
    onSortSurveyMiddle,
    onDeleteSurveyMiddle,

    //Survey thank you
    onAddThankYou,
    onEditThankYou,
    onListThankYou,
    onViewThankYou,
    onSortThankYou,
    onDeleteThankYou,

    //Raters Type
    onAddRatersType,
    onEditRatersType,
    onViewRatersType,
    onListRatersType,
    onSortRatersType,
    onDeleteRatersType,

    //Raters Type Text
    onAddRatersTypeText,
    onEditRatersTypeText,
    onListRatersTypeText,
    onViewRatersTypeText,
    onDeleteRatersTypeText,

    onProfileUpdate,
    onProfileView,
    onPasswordChange,

    // utility
    fetchLanguageList,
    fetchQuestionList,
    fetchQuestionnaireList,
    ratersInvitationsList,
    participantsInvitaionsList,
    ratersRemindersList,
    participantsRemindersList,
    fetchQuestionnaireBatchList,

    // ******************************** => Participant // Rater Panel <= **************************************
    postParticipantLogin,
    postParticipantLogout,
    onParticipantProfileView,
    onParticipantProfileUpdate,
    onParticipantPasswordChange,
    onSendMail,
    onRatersInviteList,
    surveyList,
    surveyEdit,
    getHorizontalList,
    getVerticalList,
    mailInvite,
    onSaveQuestionAnswer,
    onSaveFinalsubmissionQuestionAnswer,
    getTemplate,
    getQuestionById

};